import {Record} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';
import Table from 'web-app/react/components/table/model';

import * as Actions from './actions';

interface ReportStateProps {
    fetching: boolean;
    csvLink: string | null;
    expandedCsvLink: string | null;
    tableData: ReturnType<typeof Table.record>;
    lastUpdatedAt: any | null;
}

export class ReportState extends Record<ReportStateProps>({
    fetching: true,
    csvLink: null,
    expandedCsvLink: null,
    tableData: new Table.record(),
    lastUpdatedAt: null,
}) {}

export default makeReducer<ReportState>(
    [
        match(Actions.fetchReport, (state, {payload}) =>
            payload.initial
                ? new ReportState({
                      fetching: true,
                  })
                : state.merge({
                      fetching: true,
                  }),
        ),
        match(Actions.fetchReportFailed, state =>
            state.merge({
                fetching: false,
                csvLink: null,
                expandedCsvLink: null,
                tableData: new Table.record(),
            }),
        ),
        match(Actions.fetchReportSuccess, (state, {payload}) =>
            state.merge({
                fetching: false,
                csvLink: payload.csvLink,
                expandedCsvLink: payload.expandedCsvLink,
                tableData: payload.table,
                lastUpdatedAt: payload.lastUpdatedAt,
            }),
        ),
    ],
    new ReportState(),
);
